module.exports = __webpack_public_path__ + "static/media/EastHampton_1.77314b74.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_1.JPG
// module id = 91
// module chunks = 0